import { Component, OnInit } from '@angular/core';
import {MenuItem, Message} from "primeng/primeng";
import {AuthenticationService} from "../Login/authentication.service";
import {Router} from "@angular/router";


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  constructor(private authenticationService:AuthenticationService,private router: Router,) { }
  private items: MenuItem[];
  verMenu = true;
  role = localStorage.getItem('role');
  msgs: Message[] = [];

  ngOnInit() {
    this.items = [
      /*{
        label: 'Inicio',
        icon:'fa fa-home',
        routerLink: ['/inicio']
      },*/
      {
        label: 'Administracion',
        icon:'fa-universal-access',
        items: [
          { label: 'Usuarios',icon: 'fa-user',command: (event) => {
            if(this.role == 'Administrador'){
              this.router.navigate(['/usuario']);
            }else {
              this.mensajes('warn','Atencion','Usted no tiene permisos para acceder a esta funcionalidad.');
            }
          }},
          { label: 'Empleados',icon: 'fa fa-users',command: (event) => {
            if(this.role == 'Administrador' || this.role == 'Propietario'){
              this.router.navigate(['/empleado']);
            }else {
              this.mensajes('warn','Atencion','Usted no tiene permisos para acceder a esta funcionalidad.');
            }
          }},
          { label: 'Provedores',icon: 'fa fa-handshake-o',routerLink: ['/provedor']},
          { label: 'Tienda',icon: 'fa fa-credit-card',routerLink: ['/tienda']},
          { label: 'Categorias',icon: 'fa fa-code-fork',routerLink: ['/categoria']},
          {label: 'Historial', icon: 'fa fa-history',command: (event) => {
            if(this.role == 'Administrador' || this.role == 'Propietario'){
              this.router.navigate(['/historial']);
            }else {
              this.mensajes('warn','Atencion','Usted no tiene permisos para acceder a esta funcionalidad.');
            }
          }},
          //{label: 'Lista Precio', icon: 'fa fa-list-ol',routerLink: ['/listaPrecio']},
          {label: 'Cliente', icon: 'fa fa-reddit-alien',routerLink: ['/cliente']},
          {label: 'Reportes', icon: 'fa fa-bar-chart',routerLink: ['/reporte']},
          {label: 'Salir', icon: 'fa fa-sign-out',command: (event) => {
            this.logOut();
          }},
        ]
      },
      {
        label: 'Productos',
        icon: 'fa-product-hunt',
        items: [
          {label: 'Gestion', icon: 'fa-plus',routerLink: ['/producto']},
          {label: 'Combo', icon: 'fa fa-object-group',routerLink: ['/combo']},
          {label: 'Inventario', icon: 'fa-archive',routerLink: ['/inventario']},
          {label: 'Traslado', icon: 'fa-stack-overflow',routerLink: ['/traslado']},
          {label: 'Orden Compra', icon: 'fa fa-shopping-cart',command: (event) => {
            if(this.role == 'Administrador' || this.role == 'Propietario'){
              this.router.navigate(['/ordenCompra']);
            }else {
              this.mensajes('warn','Atencion','Usted no tiene permisos para acceder a esta funcionalidad.');
            }
          }}
        ]
      },
      {
        label: 'Efectivo',
        icon: 'fa fa-usd',
        items: [
          {label: 'Gasto', icon: 'fa fa-outdent',routerLink: ['/gasto']},
          {label: 'Separado', icon: 'fa fa-database',routerLink: ['/separado']},
        ]
      }
    ];
  }

  logOut(){
    this.verMenu = false;
    this.authenticationService.logout();
    window.location.href='/';
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
}




// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/navbar/navbar.component.ts